module.exports = __webpack_public_path__ + "img/creditcard.2b6df74.svg";